// extracted by mini-css-extract-plugin
module.exports = {"icon":"OfferFormContentSecondStep_icon__23Y_s"};